import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Router } from '@angular/router';
import { SettingsService } from '../../../../core/settings/settings.service';
import * as moment from 'moment';
import { CeqTableComponent } from '../../../common/ceq-table/ceq-table.component';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { TransportLineService } from '../transport-line.service';
import { TransportLine } from '../../../common/models/TransportLine.Model';
import { UserLogin } from '../../../common/models/UserLogin.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-carrier-list',
  templateUrl: './transport-line-list.component.html',
  styleUrls: ['./transport-line-list.component.scss']
})
export class TransportLineListComponent implements OnInit {

  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;
  
  options: GridOptions;
  lineList: TransportLine[] = [];
  keyword = "LineName";
  selectedLine: string;
  userLogin: UserLogin;
  line: string = 'undefined';

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked: (params: any) => this.edit(params),
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  };

  columnDefs = [
    { headerName: 'ID', field: 'TransportLineId', hide: true },
    { headerName: 'Línea', field: 'LineName', flex: 2, sortable: true, resizable: true },
    { headerName: 'Razón Social', field: 'FiscalName', flex: 2, sortable: true, resizable: true },
    { headerName: 'RFC', field: 'TransportNIT', flex: 1, sortable: true, resizable: true },
    { 
      headerName: 'Última modificación', 
      field: 'ModifiedAt', 
      flex: 1, 
      cellRenderer: (params: any) => params.value ? moment(params.value).format('YYYY-MM-DD HH:mm') : '-' 
    },
    { headerName: 'Modificado por', field: 'ModifiedBy', flex: 1 },
    { headerName: 'Editar', width: 80, cellRenderer: 'childEditRenderer', cellClass: 'text-center' },
    { headerName: 'Eliminar', width: 80, cellRenderer: 'childDeleteMessageRenderer', cellClass: 'text-center' }
  ];

  constructor(
    private router: Router,
    private settings: SettingsService,
    private globalFunctionService: GlobalFunctionsService,
    private transportLineService: TransportLineService
  ) { }

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
  }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getLineList();
  }

  async refresh(){
    this.getLineList();
  }

  getLineList() {
    this.transportLineService.getLines().subscribe({
      next: (data) => {
        // Ordenamos alfabéticamente al recibir
        this.lineList = data.sort((a, b) => a.LineName.localeCompare(b.LineName));
        this.getLines();
      },
      error: () => this.globalFunctionService.messageBimbo("Error al cargar transportistas", 'error', 'Error')
    });
  }

  getLines() {
    // Aseguramos que 'line' tenga un valor válido para el endpoint
    const searchTerm = this.line || 'undefined';
    this.ceqGrid.endPoint = `transportline/search/${searchTerm}`;
    this.ceqGrid.refreshTable();
  }

  selectEvent(event: any) {
    this.line = event.LineName;
    this.getLines();
  }

  cmbLines(): void {
    this.line = 'undefined';
    this.getLines();
  }

  btnAddClick() {
    window.open('/tax/transportline/create', '_blank');
  }

  edit(row: any) {
    window.open('/tax/transportline/' + row.data.TransportLineId, '_blank');
  }

  async delete(row: any) {
    const confirm = await this.globalFunctionService.messageBimbo(
      `¿Desea eliminar la línea "${row.data.LineName}"?`, 
      'question1', 
      'Confirmación'
    );

    if (confirm) {
      this.transportLineService.deleteLine(row.data.TransportLineId).subscribe({
        next: async () => {
          await this.globalFunctionService.messageBimbo('Línea de transporte eliminada.', 'success', '¡Éxito!');
          this.getLines();
        },
        error: async (err) => {
          await this.globalFunctionService.messageBimbo(err.error || 'No se pudo eliminar', 'error', '¡Error!');
        }
      });
    }
  }
}